// extracted by mini-css-extract-plugin
module.exports = {"barWrapper":"PMCSearchResult__barWrapper___1Mwqh"};